export const bscZaps = [
  {
    // PancakeSwap V2
    zapAddress: '0x03c509fd85d51dc7E75fa2De06276cFA147486EA',
    ammRouter: '0x10ed43c718714eb63d5aa57b78b54704e256024e',
    ammFactory: '0xca143ce32fe78f1f7019d7d551a6402fc5350c73',
    ammPairInitHash: '0x00fb7f630766e6a796048ea87d01acd3068e8ff67d078148a3fa3f4a84f69bd5',
  },
  {
    // ApeSwap
    zapAddress: '0x10ab57c5889a00c497ce6be7ce142bb9a613e362',
    ammRouter: '0xC0788A3aD43d79aa53B09c2EaCc313A787d1d607',
    ammFactory: '0x0841BD0B734E4F5853f0dD8d7Ea041c241fb0Da6',
    ammPairInitHash: '0xf4ccce374816856d11f00e4069e7cada164065686fbef53c6167a63ec2fd8c5b',
  },
  // {
  //   zapAddress: '0x9f6C521F1f9C8C5909D2B6f490be5E9648D7F82c', // TODO: adjust zap contract for mdex
  //   ammRouter: '0x7dae51bd3e3376b8c7c4900e9107f12be3af1ba8',
  //   ammFactory: '0x3cd1c46068daea5ebb0d3f55f6915b10648062b8', // MDEX
  //   ammPairInitHash: '0x0d994d996174b05cfc7bed897dc1b20b4c458fc8d64fe98bc78b3c64a6b4d093',
  // },
];
